/**
 * Helper function to replace S3 URL with CDN URL
 * Handles all URL patterns including CMS domain prefixes
 * @param {string} url - The original image URL
 * @returns {string} - The replaced URL or original if no replacement needed
 */
export const replaceImageUrl = url => {
    if (!url) return url;
    
    // Handle CMS domain + S3 URL patterns (most common case)
    if (url.includes('https://cms.hireaminibuswithdriver.co.ukhttps://images.hirego.co.uk.s3.eu-west-2.amazonaws.com')) {
        return url.replace('https://cms.hireaminibuswithdriver.co.ukhttps://images.hirego.co.uk.s3.eu-west-2.amazonaws.com', 'https://images.hirego.co.uk');
    }
    if (url.includes('https://cms.hireaminibuswithdriver.co.ukhttps://s3.eu-west-2.amazonaws.com/images.hirego.co.uk')) {
        return url.replace('https://cms.hireaminibuswithdriver.co.ukhttps://s3.eu-west-2.amazonaws.com/images.hirego.co.uk', 'https://images.hirego.co.uk');
    }
    
    // Handle direct S3 URL patterns
    if (url.includes('s3.eu-west-2.amazonaws.com/images.hirego.co.uk')) {
        return url.replace('https://s3.eu-west-2.amazonaws.com/images.hirego.co.uk', 'https://images.hirego.co.uk');
    }
    if (url.includes('images.hirego.co.uk.s3.eu-west-2.amazonaws.com')) {
        return url.replace('https://images.hirego.co.uk.s3.eu-west-2.amazonaws.com', 'https://images.hirego.co.uk');
    }
    
    return url;
};
